export function makeMap<T extends any>(models: T[], key = '_id'): Record<string, T> {
  const map: Record<string, T> = {};
  for (let i = 0; i < models.length; i++) {
    map[models[i][key]] = models[i];
  }

  return map;
}
